export default "__VITE_ASSET__9120fda0__"